import React, { ReactNode } from 'react';
import styles from './Content.module.css';
import { Row, Col } from 'react-bootstrap';
import classnames from 'classnames';

interface ContentProps {
  isLoading:  boolean;
  children:   ReactNode;
}

export const Content: React.FC<ContentProps> = (props: ContentProps) => {
  return (
    <Row
      className={classnames(
        styles.root,
        { [styles.isLoading]: props.isLoading }
      )}
    >
      { props.isLoading &&
        <Col xs="auto">
          <span
            className={classnames(
              styles.loader,
              "spinner-border"
            )}
            role="status"
            aria-hidden="true">
          </span>
        </Col>
      }
      { !props.isLoading && props.children }
    </Row>
  );
};

export default Content;
